import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getInternalOrg } from '@utils'
import { useQuery } from 'react-query'
import { genericOrgs } from '@src/api/generic'
import Spinner from '@src/@core/components/spinner/Fallback-spinner'

const OrgRedirect = ({ fallbackRoute = '/home', showSpinner = false }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const internalOrgId = getInternalOrg()

  const { data: orgsData } = useQuery(['genericOrgs'], () => genericOrgs(), { enabled: !!internalOrgId })

  useEffect(() => {
    if (internalOrgId) {
      if (orgsData?.data) {
        const org = orgsData.data.find(o => o.id === internalOrgId)
        if (org?.moniker) navigate(`/intOrg/${org.moniker}`, { state: { openCart: location?.state?.openCart || false }, replace: true })
        else navigate(fallbackRoute, { replace: true })
      }
    } else navigate(fallbackRoute, { replace: true })
  }, [internalOrgId, orgsData, navigate, fallbackRoute])

  return showSpinner ? <Spinner type='grow' color='primary' /> : null
}

export default OrgRedirect
